import { Crown, Briefcase, GraduationCap, User, CalendarDays } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import { getQualificationLabel } from "@/shared/lib/genderedLabels";

export type UserQualification = "socio_gestor" | "socio" | "associado" | "estagiario" | "colaborador" | "controller";

const qualificationConfig: Record<
  UserQualification,
  { Icon: React.ComponentType<{ className?: string }>; iconClass: string; bgClass: string; textClass: string }
> = {
  socio_gestor: {
    Icon: Crown,
    iconClass: "text-amber-400",
    bgClass: "bg-slate-800 border-slate-600/80",
    textClass: "text-white",
  },
  socio: {
    Icon: Crown,
    iconClass: "text-amber-400",
    bgClass: "bg-amber-500 border-amber-600/60",
    textClass: "text-white",
  },
  associado: {
    Icon: Briefcase,
    iconClass: "text-white",
    bgClass: "bg-red-600 border-red-700/80",
    textClass: "text-white",
  },
  estagiario: {
    Icon: GraduationCap,
    iconClass: "text-white",
    bgClass: "bg-green-600 border-green-700/80",
    textClass: "text-white",
  },
  colaborador: {
    Icon: User,
    iconClass: "text-white",
    bgClass: "bg-blue-800 border-blue-900/80",
    textClass: "text-white",
  },
  controller: {
    Icon: CalendarDays,
    iconClass: "text-white",
    bgClass: "bg-[#a9abae] border-[#8f9194]/80",
    textClass: "text-white",
  },
};

// Legacy export – kept for backward compat but prefer getQualificationLabel()
export const qualificationLabel: Record<UserQualification, string> = {
  socio_gestor: "Sócio Gestor",
  socio: "Sócio",
  associado: "Associado",
  estagiario: "Estagiário",
  colaborador: "Colaborador",
  controller: "Controller",
};

interface UserQualificationBadgeProps {
  qualification: UserQualification;
  sexo?: string | null;
  size?: "sm" | "md";
}

const UserQualificationBadge = ({ qualification, sexo, size = "sm" }: UserQualificationBadgeProps) => {
  const config = qualificationConfig[qualification] || qualificationConfig.colaborador;
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  const label = getQualificationLabel(qualification, sexo);
  const IconComponent = config.Icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        qualification === "socio_gestor" && "font-bold",
        config.bgClass,
        config.textClass
      )}
    >
      <IconComponent className={cn(iconSize, config.iconClass)} aria-hidden />
      {label}
    </span>
  );
};

export default UserQualificationBadge;
